const ENV = {
  dev: {
    base: "https://wday-snapshot.taskus.com/api",
    ping: {
      env_id: "ec6cad81-77fb-43ce-ac0d-61c525e12743",
      client_id: "5a1b3849-0cba-4006-95ec-e56db448ceac",
      auth_url: "https://auth.pingone.com",
      redirect_uri: "https://wday-snapshot.taskus.com/",
    },
    manualLogin: false,
  },
  uat: {
    base: "https://wday-snapshot.taskus.com/api",
    ping: {
      env_id: "ec6cad81-77fb-43ce-ac0d-61c525e12743",
      client_id: "5a1b3849-0cba-4006-95ec-e56db448ceac",
      auth_url: "https://auth.pingone.com",
      redirect_uri: "https://wday-snapshot.taskus.com/",
    },
    manualLogin: false,
  },
  prod: {
    base: "https://wday-snapshot.taskus.com/api",
    ping: {
      env_id: "ec6cad81-77fb-43ce-ac0d-61c525e12743",
      client_id: "5a1b3849-0cba-4006-95ec-e56db448ceac",
      auth_url: "https://auth.pingone.com",
      redirect_uri: "https://wday-snapshot.taskus.com/",
    },
    manualLogin: false,
  },
};

export const getEnv = (env = "prod") => {
  let vars;
  if (env === "dev") {
    vars = ENV.dev;
  } else if (env === "uat") {
    vars = ENV.uat;
  } else {
    vars = ENV.prod;
  }
  return vars;
};
